import axios from 'axios';
import router from '../router/index';
import $ from 'jquery';
import Vue from 'vue';
import { Message } from 'element-ui';
const scenes = {
    state: () => ({
        items: [],
        filter: {
            searchTerm: null,
            skip: 0,
            take: 1000,
            total: 0,
            page: 1,
        },
        selectedItems: [],
        loading: true,
    }),
    mutations: {
        setScenes(state, payload) {
            state.items = payload.items;
            state.filter.total = payload.total;
        },
        setSelectedScenes(state, payload) {
            state.selectedItems = payload;
        },

    },
    actions: {

        async addUpdateScene(store, payload) {
            var res = await axios.post('/Scene/AddOrUpdate', payload);
            if (res.data.alert.hasError) {
                Message.error(res.data.alert.message);
            } else {
                Message.success(res.data.alert.message);
            }
            return res;
        },
        async toggleScene(store, payload) {
            var res = await axios.post('Scene/toggleisactive', {
                id: store.state.items[payload.index].id,
            });
            return res.data;
        },
        async copyScene(store, payload) {
            var res = await axios.post('Scene/copy', {
                id: payload,
            });
            store.dispatch('getScenes');
            return res.data;
        },
        async deleteScene(store, payload) {
            await axios
                .post('Scene/delete', {
                    id: store.state.items[payload.index].id,
                })
                .then((res) => {
                    if (res.data.alert.hasError) {
                        payload.context.$message.error(res.data.alert.message);
                    } else {
                        store.state.items.splice(payload.index, 1);
                        payload.context.$message.success(res.data.alert.message);
                        if (store.state.items.length == 0 && store.state.filter.page != 1) {
                            this.commit('setScenePage', store.state.filter.page - 1);
                        }
                        store.state.filter.total = store.state.filter.total - 1;
                    }
                });
        },
    },
    getters: {},
};
export default scenes;


// WEBPACK FOOTER //
// ./src/store/scenes.js